import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DownloadCsvService {

  constructor() { }
  
  // Reference - https://stackblitz.com/edit/angular8-json-to-csv

  /**Converts an array to a CSV string, and builds a .txt file using Blob(), this is then downloaded via browser.*/
  public downloadCSV(objArray: any[], filename: string, headerList: string[], subHeaderList: string[] = []): void {
    let csvData = this.ConvertToCSV(objArray, headerList, subHeaderList);

    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  private ConvertToCSV(objArray: any[], headerList: string[], subHeaderList: string[] = []) {
      let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      let row = 'R.No,';

      for (let index in headerList) {
          row += headerList[index] + ',';
      }
      row = row.slice(0, -1);
      str += row + '\r\n';

      if (subHeaderList.length > 0) {
        for (let index in subHeaderList) {
          str += subHeaderList[index] + ',';
        }
        str = str.slice(0,-1);
        str += '\r\n';
      }

      for (let i = 0; i < array.length; i++) {
          let line = (i+1)+'';
          for (let index in headerList) {
            let head = headerList[index];
            line += ',' + array[i][head];
          }
          str += line + '\r\n';
      }
      return str;
  }

}
